import type { DateISO8601 } from "@/types";

import { t } from "i18next";

import { format } from "@/utilities/date";

export const getSaveBarMessage = (date?: DateISO8601) => {
  const formattedDate = format(date) ?? "";
  const msg = formattedDate
    ? `${t("global:upToDate")} | ${t("global:lastModification")} ${formattedDate}`
    : `${t("global:upToDate")}`;

  return msg;
};
